module.exports = __webpack_public_path__ + "img/hadamard-xy.4b12a706.svg";